import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LibraryService } from 'src/app/services/Library/library.service';

@Component({
  selector: 'app-book-stock-report',
  templateUrl: './book-stock-report.component.html',
  styleUrls: ['./book-stock-report.component.css']
})
export class BookStockReportComponent implements OnInit {
  Submitted:boolean=false;
  BookStockReportList=[];
  FilePath=[];
  BookGroup=[];
  LibraryType=[];
  BookList=[];
  AuthorList=[];
  PublicationList=[];
  currentPage1:0;
  sortingOrder:0;
  itemsPerPage:40;
  pagedItems=[];
  TotalCost=0;
  TotalLostCost=0;
  loadingXLS= false;
  constructor(private  libraryservice: LibraryService,private lookupservice: LookupService, public globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService) { }

  
  currentPage = 1;
 pageSize = 20;
 recordCount = 0;
  totalPages = 0;


 numberOfPages  () {

      this.totalPages = Math.ceil(this.recordCount / this.pageSize);
  }

  nextPage  () {
      this.currentPage = this.currentPage + 1;

  }

  pageSizes  () {
      this.currentPage = 1;
      this.recordCount = 0;
      this.totalPages = 0;

  }
  BookISBNModel = {
      CurrentIndex: 0,
      PageSize: 20,
      FromDate: '',
      ToDate: '',
      IsStaff: 0,
      IsStudent: 0,
      BookTitleID:0,
      BookGroupID: 0,
      AuthorID: 0,
      Medium: 0,
      PublicationID: 0,
      LibraryTypeID: 0,
      Subject: '',
      Language: '',
      BookSerialNo: '',
      StatusID: 0,
      OrderBy: 'LibraryType',
      Order: 'ASC',
      Publication:'',
      AuthorName:'',
      BookTitle:'',
      Print:'',
  };

  Clear  () {

      this.BookISBNModel.BookTitle = '';
      this.BookISBNModel.AuthorName = '';
      this.BookISBNModel.Publication = '';
      this.BookISBNModel.LibraryTypeID = 0;
      this.BookISBNModel.Subject = '';
      this.BookISBNModel.Language = '';
      this.BookISBNModel.BookSerialNo = '';
      this.BookISBNModel.StatusID = 0;
  }



  SearchBookStockReport  () {
      this.currentPage = 1;
      this.GetBookStockReport();
       }



  GetBookStockReport  () {

      this.BookISBNModel.CurrentIndex = this.currentPage;
      this.BookISBNModel.PageSize = this.pageSize;
     this.spinnerService.show();
      this.libraryservice.GetBookStockReport(JSON.stringify(this.BookISBNModel)).subscribe( (response:any)=> {
         this.spinnerService.hide();
          this.BookStockReportList = response.BookStockReportList;

          this.recordCount = 0;
          if (this.BookStockReportList != null && response.BookStockReportList.length > 0) {
              this.recordCount = this.BookStockReportList[0].RecordCount;

          }
          this.numberOfPages();
          this.search(this.BookStockReportList);
          this.globalHelper.CheckActionStatus(response);
          var TotalCost = 0;
          var TotalLostCost = 0;
          var TotalIssueQty = 0;

          for (var i = 0; i < this.BookStockReportList.length; i++) {

              TotalCost = TotalCost+ parseFloat(this.BookStockReportList[i].Cost)
            
              if (this.BookStockReportList[i].IsLost) {
                  TotalLostCost = (TotalLostCost) + parseFloat(this.BookStockReportList[i].Cost)
              }

              // TotalIssueQty = parseFloat(TotalIssueQty) + parseFloat($scope.BookStockReportList[i].IssueQty)

          }
          this.TotalCost = TotalCost;
          this.TotalLostCost = TotalLostCost;
          // $scope.TotalIssueQty = TotalIssueQty;
      });
  };
  XLSDownload  () {
    this.loadingXLS = true;
      this.BookISBNModel.Print = 'XLS';
     this.spinnerService.show()
      this.libraryservice.GetBookStockReport(JSON.stringify(this.BookISBNModel)).subscribe( (data:any)=> {
          this.FilePath = data.FilePath;
          window.location = data.FilePath;         
              this.spinnerService.hide();
              this.loadingXLS = false;
             ;
      });
  };

  GetAllBookGroup  () {
     this.spinnerService.show();
  this.lookupservice.GetLookupsList('BookGroup', '').subscribe( (data:any)=> {
          this.BookGroup = data.LookupItems;
         this.spinnerService.hide();
      });
  };


  GetAllLibrary  () {
   this.spinnerService.hide();
      this.lookupservice.GetLookupsList('LibraryType', '').subscribe( (data:any)=> {
          this.LibraryType = data.LookupItems;
         this.spinnerService.hide();
      });
  };

  GetAllBookTitle  () {
     this.spinnerService.show();
      this.lookupservice.GetLookupsList('BookTitle', '').subscribe( (data:any)=> {
          this.BookList = data.LookupItems;
          
        this.spinnerService.show();
      });
  };


  GetAllAuthor  () {
     this.spinnerService.show();
      this.lookupservice.GetLookupsList('Author', '').subscribe( (data:any)=> {
          this.AuthorList = data.LookupItems;
        this.spinnerService.hide();
      });
  };

  GetAllPublication  () {
    this.spinnerService.show();
      this.lookupservice.GetLookupsList('Publication', '').subscribe( (data:any)=> {
          this.PublicationList = data.LookupItems;
        
         this.spinnerService.hide();
      });
  };
  query:'';
  groupedItems=[];
  PagingInit  () {
      this.sortingOrder = 0;

      this.groupedItems = [];
      this.itemsPerPage = 40;
      this.currentPage1 = 0;
      this.query = '';
  }


  groupToPages  (searchList) {
      this.pagedItems = [];
      for (var i = 0; i < searchList.length; i++) {
          if (i % this.itemsPerPage === 0) {
              this.pagedItems[Math.floor(i / this.itemsPerPage)] = [searchList[i]];
          } else {
              this.pagedItems[Math.floor(i / this.itemsPerPage)].push(searchList[i]);
          }
      }

  };


  range  (start, end) {
      var ret = [];
      if (!end) {
          end = start;
          start = 0;
      }
      for (var i = start; i < end; i++) {
          ret.push(i);
      }
      return ret;

  };


  prevPage  () {
      if (this.currentPage1 > 0) {
          this.currentPage1--;
      }
  };




  search  (searchList) {

      //$scope.filteredItems = $filter('filter')(searchList, function (item) {

      //    for (var attr in item) {
      //        if (searchMatch(item[attr], $scope.query))
      //            return true;
      //    }
      //    return false;
      //});

      this.groupToPages(searchList);
      this.currentPage1 = 0;

  };
  Print = function () {

      // window.print();

      var divContents = document.getElementById("dvContainer").innerHTML;
      divContents = divContents.replace('no record found', '');
      var printWindow = window.open('', '', 'height=400,width=800');
      printWindow.document.write('<html><head><title>Student Marks Summary</title>');
      printWindow.document.write('<style type="text/css">');
      printWindow.document.write('.t1{ border-top: 1px solid black;  border-left: 1px solid black;white-space:nowrap;font-family:Calibri;font-size:10px} .t2 { border-right: 1px solid black; border-bottom: 1px solid black;}.t3 { border-right: 1px solid black;border-bottom: 1px solid black; }');
      printWindow.document.write('</style>');
      printWindow.document.write('</head><body >');
      printWindow.document.write(divContents);
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      printWindow.print();
  }
  

  ngOnInit() {
    this.PagingInit();
    this.GetAllLibrary();
  
  }

}
